//=============================================================================
// Contents   : HRDB
//              部署マスタ登録
//              UpDateTemp
// Author     : RV光永 
// LastUpdate : 2022/12/1
// Since      : 2022/11/31
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */

/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */

/* ====== React ====== */
import React,{ useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from 'react-router-dom';
/* ====== CSS ====== */
/* ====== Image ====== */
/* ====== Component Js/Jsx ====== */
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { LeftTitleTable } from "02CommonUiParts/TableParts/LeftTitleTable";
import { Underbar } from "02CommonUiParts/OtherParts/Underbar";
import { screenMaster, USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";
/* ====== Style ====== */
import { StyleCommon } from "01Pages/Common/Style/StyleCommon";
import { CFArrayFount, CFDateFormatEdit, CFStringDecodeJP, CFStringEncodeJP } from "03CommonApiParts/CommonFunction";
import { useProvideData } from "03CommonApiParts/use-context";

/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ====== Styled Components ====== */
/* ------ページコンテンツ ------*/

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */
/* ベース64スイッチ */
const base64Swicth = true;	//エンコード処理スイッチ
const CommonStyle = StyleCommon();//共通スタイルドコンポーネント

/* ======================================================================== */  
/* ================================ dummy ================================= */  
/* ======================================================================== */

/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */

/* ========= 編集画面テンプレート ========= */
export const RegDepartment = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */
    const apiData = useProvideData();//APIデータ取得
    const navigate = useNavigate();//画面遷移用
    const location = useLocation();//遷移元データ取得用

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== hookformを定義 ====== */ 
    const { register, getValues,setValue, watch, handleSubmit,formState: { errors }, trigger, clearErrors } = useForm({
            mode: 'onBlur',
            reValidateMode: 'onChange',
            shouldUseNativeValidation: false,
            shouldUnregister: false,
            escalationCode:'false',
        });

    /* ====== useFieldArrayを定義 ====== */ 

    /* ====== useWatchを定義 ====== */ 

    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    const [loading, setLoading] = useState(false); //画面表示用
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    const [master, setMaster] = useState();//マスタデータ格納用
    const [progress, setProgress] = useState(false);// プログレスバー表示用
    const [empList, setEmpList] = useState([]);//従業員情報格納用
    // const [dataRow, setDataRow] = useState([]);//データ格納用
    const dataRow = [];

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== sessionStorageからの情報を定義 ====== */ 

    /* ====== localStorageからの情報を定義 ====== */ 
    const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
    var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const userName = userInfoValue.empJpnSrname + ' ' + userInfoValue.empJpnName;//名前
    /* CODEDIFINITION_STORAGEからコード定義を取得 */
    const screenId = CFArrayFount(screenMaster,'path',location.pathname).id;//画面Id

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 

    /* ---------------------------------------------------- */
    /* -------------------- Master ------------------------ */
    /* ---------------------------------------------------- */
	const projectSegmentMaster = master?.projectSegmentMaster;//事業セグメントマスタ
	const laborCostClassificationMaster = master?.laborCostClassificationMaster//人件費区分マスタ
    const newDataList = location.state.new.list;

    const dptCodeList = [...new Set( // new setで被りをなくす
        newDataList.map((item) => ( // 本部名の配列を作成
            item.dptCd
        ))
    )]
    const dptCodeMaster = {list: dptCodeList.map((item) => (
        {value: item}
    ))}

    const dptHqNameList = [...new Set( // new setで被りをなくす
        newDataList.map((item) => ( // 本部名の配列を作成
            item.dptHqName
        ))
    )]
    const dptHqNameMaster = {list: dptHqNameList.map((item) => (
        {value: item}
    ))}

    const dptHqEngNameList = [...new Set( // new setで被りをなくす
        newDataList.map((item) => ( // 本部英語名の配列を作成
            item.dptHqEngName
        ))
    )]
    const dptHqEngNameMaster = {list: dptHqEngNameList.map((item) => (
        {value: item}
    ))}

    const dptHqOrderList = [...new Set( // new setで被りをなくす
        newDataList.map((item) => ( // 本部英語名の配列を作成
            item.dptHqOrd
        ))
    )]
    const dptHqOrderMaster = {list: dptHqOrderList.map((item) => (
        {value: item}
    ))}

    const dptPartNameList = [...new Set( // new setで被りをなくす
        newDataList.map((item) => ( // 部名の配列を作成
            item.dptPartName
        ))
    )]
    const dptPartNameMaster = {list: dptPartNameList.map((item) => (
        {value: item}
    ))}

    const dptPartEngNameList = [...new Set( // new setで被りをなくす
        newDataList.map((item) => ( // 部英語名の配列を作成
            item.dptPartEngName
        ))
    )]
    const dptPartEngNameMaster = {list: dptPartEngNameList.map((item) => (
        {value: item}
    ))}

    const dptPartOrderList = [...new Set( // new setで被りをなくす
        newDataList.map((item) => ( // 本部英語名の配列を作成
            item.dptPartOrd
        ))
    )]
    const dptPartOrderMaster = {list: dptPartOrderList.map((item) => (
        {value: item}
    ))}

    const dptRomNameList = [...new Set( // new setで被りをなくす
        newDataList.map((item) => ( // 室名の配列を作成
            item.dptRomName
        ))
    )]
    const dptRomNameMaster = {list: dptRomNameList.map((item) => (
        {value: item}
    ))}

    const dptRomEngNameList = [...new Set( // new setで被りをなくす
        newDataList.map((item) => ( // 室英語名の配列を作成
            item.dptRomEngName
        ))
    )]
    const dptRomEngNameMaster = {list: dptRomEngNameList.map((item) => (
        {value: item}
    ))}

    const dptRomOrderList = [...new Set( // new setで被りをなくす
        newDataList.map((item) => ( // 本部英語名の配列を作成
            item.dptRomOrd
        ))
    )]
    const dptRomOrderMaster = {list: dptRomOrderList.map((item) => (
        {value: item}
    ))}

    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ====== 初期表示 ====== */ 
    useEffect(() => {
        const nowDate = new Date();
        /* APIデータ取得 */
        getMaster(CFDateFormatEdit(nowDate));
        // eslint-disable-next-line
    },[]);

    /* 従業員検索処理　*/
    const getEmployeeData = async(id) =>{
        const data = getValues(id) ? getValues(id) : '';
        setEmpList([]);
        /* プログレスバー表示 */
        setProgress(true);
        const apiPath = '/search/getemployee';	//API Path

		/* リクエスト*/
		const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';
		/* キー */
		key.aplySrtDate = location.state.new.aplySrtDate? location.state.new.aplySrtDate : null ;
		key.sarValue = CFStringEncodeJP(data,base64Swicth);

		/* リクエストパラメータ */
		const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
		await apiData.getDataPost(apiPath, apiBody, (result) => {
			/* プログレスバー非表示 */
			setProgress(false);
			if (result.isSuccessed) {//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                const list = [];
                data.forEach((item)=>{
                    list.push({
                        empNmb			:item.empNmb,		//従業員番号	       
                        empFullName		:item.empFullName ? CFStringDecodeJP(item.empFullName,base64Swicth) : '',	     //従業員氏名  
                    });
                });
                setEmpList(list);
			}else{//APIリクエスト結果 = 異常
			    /* スナックバー表示 */
			    setSnackbarMessage({      
			        ...snackbarMessage,
			        open:true,
			        message:result,//APIによるエラー
			        $1:result.responseData ? result.responseData.data.metadata: '',//取得件数
			        type: 1,//APIエラー時:1,それ以外:2 
			        level:'error',//エラースナックバー
			    })
			}
		});
    };
    /* ====== マスタの取得処理 ====== */
    const getMaster = async(date) => {

        /* リクエスト先 */
        const apiPath = '/search/getmaster';
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';

        /* キー */
        key.aplySrtDate = date;
        key.mstList = ['projectSegmentMaster', 'laborCostClassificationMaster', 'departmentMaster'];

        /* リクエストパラメータ */
        const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            setLoading(true);
            /* APIリクエスト結果を判定 */
            if(result.isSuccessed){//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                const masterList = {};
                data.forEach((item)=>{
                    const masterSmallList = [];
                    item.list.forEach((master)=>{
                        masterSmallList.push({
                            value:master.value,
                            label:CFStringDecodeJP(master.label,base64Swicth)
                        });
                    });
                    masterList[item.code] = {
                        code:item.code,
                        name:CFStringDecodeJP(item.name,base64Swicth),
                        list:masterSmallList
                    };
                });
                // createBodyData(masterList);
                setMaster(masterList);
                // getData();

            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
            }

        });
    };

    /* ====== 戻るボタン押した時の処理 ====== */
    const onClickBack = () => {
        navigate('/master/department/list', {state: {old: location.state.old, new: location.state.new, type: location.state.type}, replace: true})
    };

    /* ====== 完了ボタンを押した時の処理 ====== */
    const onClickSubmit = (data) => {
        //更新後dataの事業セグメントマスタを取得
        const projSgmtMast = CFArrayFount(projectSegmentMaster.list, 'value', getValues('payload.projSgmtCd')); 
        //事業セグメントマスタのラベルを取得
        const projSgmtName = projSgmtMast ? projSgmtMast.label : null
        //更新後data中の事業セグメントコードを「事業セグメントコード＋事業セグメント名」に変える
        const payload = JSON.parse(JSON.stringify(getValues('payload')));
        payload.projSgmtCd = projSgmtMast ? 
            getValues('payload.projSgmtCd') + ' ' + projSgmtName
        :null;
        // locationの配列に入力情報を追加
        const changeData = location.state.new.list.concat(payload);
        // 追加後のデータをソート
        const list = Array.from(changeData).sort((a, b) => {
            const dptOrd1 = ('00' + a.dptHqOrd).slice(-2) + ('00' + a.dptPartOrd).slice(-2) + ('00' + a.dptRomOrd).slice(-2) + ('00' + a.dptGpOrd).slice(-2);
            const dptOrd2 = ('00' + b.dptHqOrd).slice(-2) + ('00' + b.dptPartOrd).slice(-2) + ('00' + b.dptRomOrd).slice(-2) + ('00' + b.dptGpOrd).slice(-2);
            // console.log(dptOrd1, dptOrd2)
            return dptOrd1 > dptOrd2 ? 1 : -1;
        });
        navigate('/master/department/list', {state: {old: location.state.old, new: {...location.state.new, list}, type: location.state.type}, replace: true})
    };

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== LeftTitleテーブルの設定 ====== */
    //id:idを指定
    //label:左側に表示するタイトル*
    //list:右側に表示するコンテンツのリスト *
    //name:項目名
    //name2:項目名(type:categoryLabelを選択時のみ指定　minorCategory)
    //title:inputなどの隣に表示するタイトル
    //type:表示タイプ label/input/select/date/datetime/categoryLabel(問合せ情報問合せ種別用) *
    //rightLabel:inputなどの隣に表示するラベル 例：メールドメインなど
    //disable:変更不可にする true/false
    //readOnly:ラベル風にする　true/false（select/date/datetime)
    //width:幅の変更をする(inputのみ)

    /* ====== LeftTitleテーブルのデータ ====== */
    const inquieyTableConfig = 
    [
        /*部署コード */
        {
            id:'row1', 
            label:'部署コード', 
            required:true, 
            list:[
                {name:'dptCd',   type:'input',maxLength:8,placeholder:'8文字まで', required: true,pattern:'script'},//本部名
            ]
        },
        /*本部名 */
        {
            id:'row2', 
            label:'本部名', 
            required:true, 
            list:[
                {name:'dptHqName',   type:'inputList',title:'本部日本語名：',maxLength:128,master:dptHqNameMaster,width:'280px',placeholder:'128文字まで',required: true, noValidation: true},//本部名
                {name:'dptHqEngName', type:'inputList',title:'本部英名：',maxLength:128,master:dptHqEngNameMaster,width:'280px',placeholder:'128文字まで(任意)', noValidation: true,pattern:'englishScript'},
                {name:'dptHqOrd', type:'inputList',title:'本部順：', maxLength:3,master:dptHqOrderMaster,width:'120px',placeholder:'3文字まで',required: true, noValidation: true, pattern:'number'},
            ]
        },
        /*部名 */
        {
            id:'row3', 
            label:'部名',
            list:[
                {name:'dptPartName',   type:'inputList',title:'部日本語名：',maxLength:128,master:dptPartNameMaster,width:'280px',placeholder:'128文字まで', noValidation: true},//本部名
                {name:'dptPartEngName', type:'inputList',title:'部英名：',maxLength:128,master:dptPartEngNameMaster,width:'280px',placeholder:'128文字まで', noValidation: true,pattern:'englishScript'},
                {name:'dptPartOrd', type:'inputList',title:'部順：', maxLength:3,master:dptPartOrderMaster,width:'120px',placeholder:'3文字まで', noValidation: true,pattern:'number'},
            ]
        },
        /*室名 */
        {
            id:'row4', 
            label:'室名',
            list:[
                {name:'dptRomName',   type:'inputList',title:'室日本語名：',maxLength:128,master:dptRomNameMaster,width:'280px',placeholder:'128文字まで', noValidation: true},//本部名
                {name:'dptRomEngName', type:'inputList',title:'室英名：',maxLength:128,master:dptRomEngNameMaster,width:'280px',placeholder:'128文字まで', noValidation: true,pattern:'englishScript'},
                {name:'dptRomOrd', type:'inputList',title:'室順：', maxLength:3,master:dptRomOrderMaster,width:'120px',placeholder:'3文字まで', noValidation: true,pattern:'number'},
            ]
        },
        /*G名 */
        {
            id:'row4', 
            label:'G名',
            list:[
                {name:'dptGpName',   type:'input',title:'G日本語名：',maxLength:128,width:'280px',placeholder:'128文字まで'},//本部名
                {name:'dptGpEngName', type:'input',title:'G英名：',maxLength:128,width:'280px',placeholder:'128文字まで',pattern:'englishSpace'},
                {name:'dptGpOrd', type:'input',title:'G順：', maxLength:3,width:'120px',placeholder:'3文字まで',pattern:'number'},
            ]
        },
        /*部署略名 */
        {
            id:'row5', 
            label:'部署略名',
            list:[
                {name:'dptAbrName', type:'input',maxLength:128,width:'280px',placeholder:'128文字まで'},
            ]
        },
        /*上位部署コード */
        {
            id:'row7', 
            label:'上位部署コード',
             list:[
                {name:'upperDptCd', type:'inputList',maxLength:8,placeholder:'8文字まで',pattern:'script', width:  '157px', master: dptCodeMaster},
            ]
        },
        /*部署レベル */
        {
            id:'row8', 
            label:'部署レベル', 
            required:true,
            list:[
                {name:'dptLevel', type:'input',maxLength:1,width:'50px', required: true,placeholder:'1文字',pattern:'number'},
            ]
        },
        /*人件費区分 */
        {
            id:'row9', 
            label:'人件費区分',
             required:true,
             list:[
                {name:'lboCstClasfCd', type:'select',master:laborCostClassificationMaster, required: true},
            ]
        },
        /*事業セグメント */
        {
            id:'row10', 
            label:'事業セグメント',
            list:[
                {name:'projSgmtCd', type:'select',master:projectSegmentMaster},
            ]
        },
        /*部内共通(KBJ)コード */
        {
            id:'row11', 
            label:'部内共通(KBJ)コード',
            list:[
                {name:'partWithinCmmKbjCd', type:'input',maxLength:13,placeholder:'13文字まで',pattern:'symbol'},
            ]
        },
        /*販管費PJコード*/
        {
            id:'row12', 
            label:'販管費PJコード',
            list:[
                {name:'salesMnaExpePjCd', type:'input',maxLength:13,placeholder:'13文字まで',pattern:'symbol'},
            ]
        },
        /*人件費PJコード*/
        {
            id:'row13', 
            label:'人件費PJコード',
            list:[
                {name:'lboCstPjCd', type:'input',maxLength:13,placeholder:'13文字まで',pattern:'symbol'},
            ]
        },
        /*契約書提出日 */
        {
            id:'row14', 
            label:'所属長', 
            list:[
                {name:'mnaEmpNmb', type:'inputVariableList',master:empList, onClickButton:getEmployeeData,},
            ]
        },
    ];

    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ====== 画面表示開始前 ====== */
    if(!loading){
        return(
        <></>
        );
    };


    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
            {/* プログレスバーの表示 */}
            <LoadingProgressBar open={progress}/>
            {/* 画面タイトル */}
            <form onSubmit={handleSubmit(onClickSubmit)}>
                <CommonStyle.GdivPageContentsWrapper>
                {/* ページコンテンツ */}
                    {/* 問合せ情報テーブル */}
                    <CommonStyle.GdivSubTitleWrapper id='inquiry'>
                        部署マスタメンテ登録
                    </CommonStyle.GdivSubTitleWrapper>
                    <LeftTitleTable
                        className='baseText'
                        register={register}
                        payload='payload'
                        errors={errors}
                        dataRow={dataRow}
                        tableConfig={inquieyTableConfig}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        trigger={trigger}
                        payloadData={watch('payload')}
                    />
                </CommonStyle.GdivPageContentsWrapper>
                {/* アンダーバー */}
                <Underbar
                     payload="payload"  //react-hook-form
                     register={register} //react-hook-form
                     error={errors} //react-hook-form
                     type='completeSubmitBack' //react-hook-form
                     onClickLeft={onClickBack}//戻るボタン押下時の処理
                 />
            </form>
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}
            />
                
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */